import {
  CpRefundsItemListInterface
} from '../../../../interfaces/response/refunds/refunds-item-list/cp-refunds-item-list-interface';
import { CpRefundsModel } from '../../../dto/refunds/cp-refunds-model';

export class CpRefundsItemListResponseModel implements CpRefundsItemListInterface {
  ProcessNr: string = '';
  Type: string = '';
  PersonName: string = '';
  ExpenseDate: string = '';
  InvoiceNr: string = '';
  TotalValue: number = 0;
  Status: string = '';
  Claims: CpRefundsModel[] = new Array<CpRefundsModel>();

  constructor(init?: Partial<CpRefundsItemListResponseModel>) {
    Object.assign(this, init);
  }
}
